import LegalLayout from "./LegalLayout";
import { BRAND } from "@/components/Brand";

export default function Cookies() {
  const clearConsent = () => {
    try {
      localStorage.removeItem("cookie_consent");
      window.location.reload();
    } catch { /* ignore */ }
  };
  return (
    <LegalLayout title="Política de Cookies">
      <p>En {BRAND.name} utilizamos únicamente las cookies estrictamente necesarias para el funcionamiento del servicio y, si tú lo autorizas, cookies analíticas para mejorar la aplicación.</p>

      <h2>1. ¿Qué son las cookies?</h2>
      <p>Una cookie es un pequeño fichero de texto que un sitio web guarda en tu navegador cuando lo visitas. Se utilizan para recordar información sobre la visita, como la sesión iniciada o las preferencias.</p>

      <h2>2. Cookies que utilizamos</h2>
      <h3>Cookies técnicas (siempre activas, exentas de consentimiento)</h3>
      <table className="w-full text-sm border border-white/10 rounded-lg overflow-hidden">
        <thead className="bg-white/5">
          <tr>
            <th className="text-left p-2">Nombre</th>
            <th className="text-left p-2">Finalidad</th>
            <th className="text-left p-2">Duración</th>
          </tr>
        </thead>
        <tbody className="text-slate-300">
          <tr className="border-t border-white/10"><td className="p-2 font-mono">access_token</td><td className="p-2">Mantener la sesión de usuario iniciada</td><td className="p-2">7 días</td></tr>
          <tr className="border-t border-white/10"><td className="p-2 font-mono">session_token</td><td className="p-2">Sesión de Google Sign-In (si aplica)</td><td className="p-2">7 días</td></tr>
          <tr className="border-t border-white/10"><td className="p-2 font-mono">workshop_code</td><td className="p-2">Compatibilidad con acceso por código legacy</td><td className="p-2">Persistente hasta cierre de sesión</td></tr>
          <tr className="border-t border-white/10"><td className="p-2 font-mono">cookie_consent</td><td className="p-2">Recordar tu decisión sobre cookies</td><td className="p-2">12 meses</td></tr>
        </tbody>
      </table>

      <h3>Cookies analíticas (requieren consentimiento)</h3>
      <table className="w-full text-sm border border-white/10 rounded-lg overflow-hidden">
        <thead className="bg-white/5">
          <tr>
            <th className="text-left p-2">Nombre / Origen</th>
            <th className="text-left p-2">Finalidad</th>
            <th className="text-left p-2">Duración</th>
          </tr>
        </thead>
        <tbody className="text-slate-300">
          <tr className="border-t border-white/10"><td className="p-2 font-mono">ph_ (PostHog)</td><td className="p-2">Analítica agregada del uso del servicio para mejorar la aplicación</td><td className="p-2">12 meses</td></tr>
        </tbody>
      </table>

      <h2>3. Cómo gestionar las cookies</h2>
      <p>La primera vez que visitas el Sitio te mostramos un banner con tres opciones: <strong>Aceptar</strong>, <strong>Rechazar</strong> o <strong>Personalizar</strong>. Puedes cambiar tu decisión en cualquier momento pulsando el botón siguiente o borrando las cookies de tu navegador.</p>
      <button
        onClick={clearConsent}
        className="not-prose px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-sm"
        data-testid="reset-cookies-btn"
      >
        Restablecer mis preferencias de cookies
      </button>

      <h2>4. Cookies de terceros</h2>
      <p>Los proveedores mencionados en la Política de Privacidad (Stripe, Google, Resend, Emergent, PostHog) pueden establecer cookies propias cuando accedes a sus servicios integrados. Las cookies analíticas de PostHog solo se instalan si aceptas expresamente.</p>

      <h2>5. Más información</h2>
      <p>Puedes consultar la guía sobre cookies de la Agencia Española de Protección de Datos: <a href="https://www.aepd.es/es/derechos-y-deberes/conoce-tus-derechos/cookies">www.aepd.es/es/derechos-y-deberes/conoce-tus-derechos/cookies</a>.</p>
    </LegalLayout>
  );
}
